import "./styles.css";
import PartySocket from "partysocket";
var socket;

const defaultAvatar = "https://postread.com/f/icon.svg";
var id = "";
var status = "";
var avatar = defaultAvatar;
var username = "x";
var room = "";
var effectedUser = "";

document.addEventListener("handleFileDrop", e => {
  let img = new Image();
  img.onload = () => {
    let canvas = document.createElement('canvas');
    let scale = 100 / img.width;
    canvas.width = 100;
    canvas.height = img.height * scale;
    let ctx = canvas.getContext('2d');
    ctx.drawImage(img, 0, 0, canvas.width, canvas.height);
    avatar = canvas.toDataURL();
    updateStatusData();
  };
  img.src = 'data:image/png;base64,' + e.detail.base64;
});

document.addEventListener("windowClosed", e => {
  sendMessage(effectedUser, `windowClosed:${id}`);
});
document.addEventListener("drawPath", e => {
  sendMessage(effectedUser, `drawPath:${e.detail.x}:${e.detail.y}`);
});
document.addEventListener("startPath", e => {
  sendMessage(effectedUser, `startPath:${e.detail.x}:${e.detail.y}`);
});
document.addEventListener("sleep", e => {
  socket.close();
  if(!document.querySelector("#connected").classList.contains("hidden"))
  document.querySelector("#connected").classList.add("hidden");
  document.querySelector("#disconnected").classList.remove("hidden");
});
document.addEventListener("awake", e => {
  connect();
});

const updateStatusData = () => {
  if(!socket) return;
  let jsonObject = {
    "type": "connect",
    "username": username || "Ghost",
    "status": status,
    "avatar": avatar,
  };
  let jsonData = JSON.stringify(jsonObject);
  socket.send(jsonData);
  
  if(username.length > 0)
  console.log(`setName:${username}`);
  if(status.length > 0)
  console.log(`setStatus:${status}`);
  if(room.length > 0)
  console.log(`setRoom:${room}`);
  if(avatar != defaultAvatar)
  console.log(`setAvatar:${avatar}`);
  
  try {
    localStorage.setItem("username", username);
    localStorage.setItem("room", room);
    localStorage.setItem("status", status);
    localStorage.setItem("avatar", avatar);
  }
  catch(err) {}
};

const connect = () => {
  
  if(room == "") return;
  if(socket && socket.readyState == 1) return;
  
  socket = new PartySocket({
    host: PARTYKIT_HOST,
    room: room.toLowerCase()
  });
  
  socket.addEventListener("message", function (event) {
    const data = JSON.parse(event.data);
    
    // User list
    try {
      if(data.online_users) {
        processOnline(data.online_users);
        return;
      }
    }
    catch(err) {
      console.log(event.data);
    }
    
    // Someone Left
    if(data.type && data.type == "someoneLeft") {
      console.log(`someoneLeft:${data.from}`);
      return;
    }
    
    // Drawing
    if(data.type && data.type == "draw:✏️") {
      if(data.to == id) {
        console.log("drawViewer");
      }
      if(data.from == id) {
        console.log("drawCreator");
      }
      return;
    }
    
    if(data.type && (data.to == id || data.from == id)) {
      console.log(data.type);
    }
  });
  
  socket.addEventListener("open", function () {
    id = socket._pk;
    updateStatusData();
    leaveButton.textContent = `Exit "${room}"`;
  });
  
  socket.addEventListener("close", function () {
    if(!document.querySelector("#connected").classList.contains("hidden"))
    document.querySelector("#connected").classList.add("hidden");
    document.querySelector("#disconnected").classList.remove("hidden");
  });
  
  socket.onerror = function(error) {
    console.log('WebSocket Error: ' + error);
    if(!document.querySelector("#connected").classList.contains("hidden"))
    document.querySelector("#connected").classList.add("hidden");
    document.querySelector("#disconnected").classList.remove("hidden");
  };
  
  socket.onclose = function(event) {
    if(!document.querySelector("#connected").classList.contains("hidden"))
    document.querySelector("#connected").classList.add("hidden");
    document.querySelector("#disconnected").classList.remove("hidden");
    console.log('WebSocket is closed now.');
  };
};

const leaveButton = document.querySelector("#leave");
leaveButton?.addEventListener("click", e => {
  socket.close();
  if(!document.querySelector("#connected").classList.contains("hidden"))
  document.querySelector("#connected").classList.add("hidden");
  document.querySelector("#disconnected").classList.remove("hidden");
});

const statusInput = document.querySelector("#status");
statusInput?.addEventListener("keyup", e => {
  if(e.key == "Enter") {
    updateStatus.click();
    return;
  }
  if(statusInput.value.length > 0) {
    if(!updateStatus.classList.contains("ready")) {
      updateStatus.classList.add("ready");
    }
    return;
  }
  updateStatus.classList.remove("ready");
  
  // try {
  // 	const url = new URL(statusInput.value);
  // 	if(!updateStatus.classList.contains("ready")) {
  // 		updateStatus.classList.add("ready");
  // 	}
  // }catch(err) {
  // 	updateStatus.classList.remove("ready");
  // }
});

const updateStatus = document.querySelector("#update");
updateStatus?.addEventListener("click", e => {
  const inputValue = document.querySelector("#status").value;
  try {
    if(!statusInput) return;
    // new URL(inputValue);
    status = statusInput.value;
    updateStatusData();
    statusInput.value = "";
    updateStatus.classList.remove("ready");
  }catch(err) {}
});

const usernameInput = document.querySelector("#user");
const roomInput = document.querySelector("#room");
const b = document.querySelector("#connect");
b.addEventListener("click", e => {
  e.preventDefault();
  if(usernameInput.value.trim() == "") return;
  if(roomInput.value.trim() == "") return;
  username = usernameInput.value.trim();
  room = roomInput.value.trim();
  connect();
});

const addFriendInput = document.querySelector("#addFriendInput");
addFriendInput?.addEventListener("keyup", e => {
  if(e.key == "Enter") {
    const v = addFriendInput.value;
    addFriendInput.value = "";
    addFriendInput.blur();
    return;
  }
});

const sendMessage = (to, msg, data = null) => {
  let jsonObject = {
    "type": msg, 
    "to": to, 
    "from": id,
  };
  if(data) {
    jsonObject.data = data;
  }
  let jsonData = JSON.stringify(jsonObject);
  socket?.send(jsonData);
}

const processOnline = (online) => {
  document.querySelector("#connected").classList.remove("hidden");
  if(!document.querySelector("#disconnected").classList.add("hidden"))
  document.querySelector("#disconnected").classList.add("hidden");
  document.querySelector("#list").innerHTML = "";
  online.forEach(u => {
    const person = document.createElement("div");
    person.innerHTML = `
      <img src="${u.avatar}">
      <div class="meta">
        <div class="username">${u.username}</div>
        <div class="url" style="display: none;">${ u.status.trim().length == 0 ? "&nbsp;" : u.status }</div>
        <div class="actions">
          <div class="buttons">
            <button action="fullscreen">❤️</button>
            <button action="randomWiggle">👋</button>
            <button action="msg">💬</button>
            <button action="look">👀</button>
            <button action="note">🟨</button>
            <button action="late">⏰</button>
            <button action="draw" style="display:none;">✏️</button>
          </div>
          <input placeholder="Message..." class="hidden">
        </div>
      </div>
    `;
    if(u.id == id) {
      document.querySelector("#currentUser").innerHTML = "";
      document.querySelector("#currentUser").appendChild(person);
      
      const statusInput = person.querySelector(".url");
      statusInput.setAttribute("contenteditable", "true");
      statusInput.addEventListener('keydown', (e) => {
        if(e.key == "Enter") {
          e.preventDefault();
          statusInput.blur();
        }
      });
      statusInput.addEventListener('blur', () => {
        status = statusInput.textContent.trim();
        updateStatusData();
      });
      
      const usernameInputEl = person.querySelector(".username");
      usernameInputEl.setAttribute("contenteditable", "true");
      usernameInputEl.addEventListener('keydown', (e) => {
        if(e.key == "Enter") {
          e.preventDefault();
          usernameInputEl.blur();
        }
      });
      usernameInputEl.addEventListener('blur', () => {
        username = usernameInputEl.textContent;
        updateStatusData();
      });
      
      person.querySelector("img").setAttribute("alt", "Drag image to window to update your avatar");
      return;
    }
    
    const addInput = (placeholder, onSubmit, requireURL = false) => {
      const i = document.createElement("input");
      i.placeholder = placeholder;
      i.addEventListener("blur", e => {
        i.remove();
        person.querySelector(".buttons").classList.remove("hidden");
      });
      i.addEventListener("keyup", e => {
        if(e.key == "Escape") {
          i.blur();
          return;
        }
        if(e.key != "Enter") return;
        if(requireURL) {
          try {
            let u = new URL(i.value);
          }catch(err) {
            return;
          }
        }
        if(onSubmit) {
          onSubmit(i.value);
        }
        i.blur();
      });
      person.querySelector(".actions").appendChild(i);
      i.focus();
    };

    person.querySelectorAll("button").forEach(b => {
      b.addEventListener("click", e => {
        effectedUser = u.id;
        if(b.getAttribute("action") == "look") {
          person.querySelector(".buttons").classList.add("hidden");
          addInput("Check out this URL...", v => {
            sendMessage(u.id, `window:${id}🖖look.html?id=${id}&name=${encodeURI(username)}&url=${encodeURI(v)}`);
          }, true);
          return;
        }
        if(b.getAttribute("action") == "msg") {
          person.querySelector(".buttons").classList.add("hidden");
          addInput("Message...", v => {
            sendMessage(u.id, `message:${v}\n${username}`);
          });
          return;
        }
        if(b.getAttribute("action") == "note") {
          person.querySelector(".buttons").classList.add("hidden");
          addInput("Sticky note...", v => {
            sendMessage(u.id, `window:${id}🖖note.html?id=${id}&name=${encodeURI(username)}&text=${encodeURI(v)}`);
          });
          return;
        }
        if(b.getAttribute("action") == "late") {
          sendMessage(u.id, `window:${id}🖖late.html?name=${encodeURI(username)}`);
          return;
        }
        if(b.getAttribute("action") == "randomWiggle") {
          sendMessage(u.id, `${b.getAttribute("action")}:${b.innerText}🖖${username}`);
          return;
        }
        sendMessage(u.id, `${b.getAttribute("action")}:${b.innerText}`);
      });
    });
    
    const input = person.querySelector("input");
    input?.addEventListener("keyup", e => {
      if(e.key != "Enter") return;
      sendMessage(u.id, `message:${input.value}`);
      // console.log(`${u.id}:${input.value}`);
      input.value = "";
      // input.blur();
    });
    
    // Unused...
    person.querySelector(".url")?.addEventListener("click", e => {
      if(u.status.length == 0) return;
      try {
        const url = new URL(u.status);
        console.log(`load:${u.status}`);
      }catch(err){}
    });
    
    document.querySelector("#list").appendChild(person);
  });
};

try {
  if(localStorage.getItem("status")) {
    status = localStorage.getItem("status");
  }
  if(localStorage.getItem("avatar")) {
    avatar = localStorage.getItem("avatar");
  }
  if(localStorage.getItem("username")) {
    username = localStorage.getItem("username");
    room = localStorage.getItem("room");
    usernameInput.value = username;
    if(room != "") {
      roomInput.value = room;
    }
    connect();
  }
}catch(err) {
  usernameInput.focus();
}

